import React, {useState} from "react";
import styles from "../assets/css/contactUs.module.scss";
import {
    Box,
    Card, Checkbox,
    Container, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, FormControlLabel, FormGroup, FormHelperText,
    Grid, MenuItem,
    Typography
} from "@mui/material";
import Button1 from "./subComponents/Button1";
import {TextField} from "./subComponents/TextField";
import Select from "./subComponents/Select";
import FormControl from "./subComponents/FormControl";
import InputLabel from "./subComponents/InputLabel";
import {Link} from "react-router-dom";
import {ContactApi} from "../utils/ContactApi";
import LoadingButton from "./subComponents/LoadingButton";
import {useFormik} from "formik";
import * as yup from 'yup';

const ContactUs = (props) => {
    const [open, setOpen] = useState(false);
    const [fullWidth, setFullWidth] = useState(true);
    const [maxWidth, setMaxWidth] = useState('sm');
    const [request, setRequest] = useState('');
    const [checked, setChecked] = useState(false);
    const [sending, setSending] = useState(false);

    const [state, setState] = useState({
        name: "",
        type: "",
        mail: "",
        phone: ""

    });
    const toggleCheckBox = () => {
        setChecked(prevState => !prevState);
    }

    const handleChangeRequest = (event) => {
        setRequest(event.target.value);
    };
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleMaxWidthChange = (event) => {
        setMaxWidth(
            // @ts-expect-error autofill of arbitrary value is not handled.
            event.target.value,
        );
    };

    const handleFullWidthChange = (event) => {
        setFullWidth(event.target.checked);
    };
    const validationSchema = yup.object({
        mail: yup
            .string('پست الکترونیکی خود را وارد کنید')
            .email('پست الکترونیکی معتبر وارد کنید')
            .required('وارد کردن پست الکترونیکی اجباری ست.'),
        phone: yup
            .string('رمز عبور خود را وارد کنید.')
            .length(11,"قالب شماره تماس صحیح نمیباشد.(09XXXXXXXX)")
            // .min(8, 'Password should be of minimum 8 characters length')
            .required('وارد کردن شماره تماس الزامی ست.'),
        name: yup.string("").required("وارد کردن نام الزامی ست."),
        type: yup.string("").required("وارد کردن نوع درخواست الزامی ست.")
    });

    const formik = useFormik({
        initialValues: {
            mail: '',
            phone: '',
            name: '',
            type: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            (async () => {
                setSending(true);
                await ContactApi.insertContract({payload: JSON.stringify(values)}, (result) => {
                    setSending(false);
                    handleClose();

                }, (error) => {
                    setSending(false);
                    handleClose();

                })
            })();
        },
    });

    return <div className={styles.container}>
        <div></div>
        <div></div>
        <div>
            <Container maxWidth={"lg"} component={"div"}>
                <Card elevation={3}>
                    <Grid container className={styles.wrapper}>
                        <Grid item md={8} xs={12}>
                            <div>
                                <Typography variant={"h5"} component={"h5"}>
                                    هنوز شروع نکرده اید؟!
                                </Typography>
                            </div>

                        </Grid>
                        <Grid item md={4} xs={12}>
                            <div>
                                <Button1 variant="contained" onClick={handleClickOpen}> تماس با ما</Button1>

                            </div>
                        </Grid>
                    </Grid>
                </Card>
            </Container>
        </div>
        <Dialog
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>ارسال درخواست</DialogTitle>
            <form onSubmit={formik.handleSubmit} >

                <DialogContent>

                    <DialogContentText>
                    </DialogContentText>
                    <FormControl sx={{m: 1}} style={{width: "100%"}} error={formik.touched.type && Boolean(formik.errors.type)}>
                        <InputLabel id="demo-simple-select-autowidth-label">درخواست</InputLabel>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={formik.values.type}
                            onChange={e => {
                                formik.handleChange({
                                    target: {
                                        id: "type", value: e.target.value
                                    }
                                });
                                // setState({...state, type: e.target.value})
                            }}
                            autoWidth
                            label="درخواست"
                        >
                            <MenuItem value="">
                                <em>هیچ کدام</em>
                            </MenuItem>
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={2}>2</MenuItem>
                            <MenuItem value={3}>3</MenuItem>
                        </Select>
                        <FormHelperText>{formik.touched.type && formik.errors.type}</FormHelperText>

                    </FormControl>
                    <TextField
                        label="نام"
                        variant="outlined"
                        sx={{m: 1}}
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        error={formik.touched.name && Boolean(formik.errors.name)}
                        helperText={formik.touched.name && formik.errors.name}
                        id="name"
                        name="name"/>
                    <TextField label="پست الکترونیک" variant="outlined" sx={{m: 1}}
                               value={formik.values.mail}
                               onChange={formik.handleChange}
                               error={formik.touched.mail && Boolean(formik.errors.mail)}
                               helperText={formik.touched.mail && formik.errors.mail}
                               id="mail"
                               name="mail"/>
                    <TextField label="تلفن همراه" variant="outlined" sx={{m: 1}}
                               value={formik.values.phone}
                               onChange={formik.handleChange}
                               error={formik.touched.phone && Boolean(formik.errors.phone)}
                               helperText={formik.touched.phone && formik.errors.phone}
                               id="phone"
                               name="phone"/>

                </DialogContent>
                <DialogActions>


                    <LoadingButton
                        loading={sending}
                        loadingPosition="end"
                        variant={'text'}
                        color="primary"
                        component="submit"
                        onClick={() => {
                            formik.submitForm();
                        }}
                    >
                        ثبت
                    </LoadingButton>
                    {/*<Button1 variant="contained" onClick={e => {*/}
                    {/*    (async () => {*/}
                    {/*        await ContactApi.insertContract({payload: JSON.stringify(state)}, (result) => {*/}
                    {/*        }, (error) => {*/}
                    {/*        })*/}
                    {/*    })();*/}
                    {/*}}> ارسال درخواست</Button1>*/}
                </DialogActions>
            </form>
        </Dialog>
    </div>;
};

export default ContactUs;